module.exports = __webpack_public_path__ + "img/location-encart.44f6690b.svg";